import script from "./CardHeader.ce.vue?vue&type=script&setup=true&lang=js"
export * from "./CardHeader.ce.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__